import { useContext } from 'react';
import TurboLiveContext from '../context/TurboLiveContext';

export function useStreamIcon(match: any, streamType: 'video' | 'matchtracker') {
    const { startBetradarMT } = useContext(TurboLiveContext);
    const onStreamIconClick = () => {
        startBetradarMT(match, streamType, false);
    };
    return {
        onStreamIconClick
    };
}
